// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Assets/Images/Bg_graphic.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload {
    background: #FFFFFF;
    box-shadow: 0px 20px 24px -4px rgba(148, 93, 63, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03);
    border-radius: 8px;
    width: 70%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 70%;
    min-height: 60vh;
    margin: auto;
}

.upload_container {
    padding: 5%;
    display: flex;
    flex-direction: column;
    gap: 30px;
    justify-content: center;
}

.upload_heading,
.upload_description,
.upload_symbol {
    display: flex;
    justify-content: center;
}

.upload_heading>span {
    font-weight: 700;
    font-size: 28px;
    line-height: 42px;
    color: #3F3325;
}

.upload_description>span {
    font-weight: 400;
    font-size: 14px;
    color: #594F42;
    line-height: 20px;
}

.upload_button {
    width: 100%;
}

.upload_button>button {
    margin: auto;
    margin-top: 50px;
    width: 100%;
}

.popup-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.button-container {
    margin-top: 25px;
    display: flex;
    justify-content: flex-end;
}

.drop_container {
    height: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
}

.drop_container>span {
    color: #9A938A;
    font-weight: 700;
    font-size: 28px;
    line-height: 42px;
}

.upload_folder {
    position: absolute;
    left: 70%;
    top: 40%;
}


.Upload {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
    width: 100%;
    height: 100vh;
    background-position: center center;
    background-attachment: fixed;
    background-size: cover;
    overflow: auto;
}


.UploadProperties {
    background: #FFFFFF;
    border: 1px dashed #E8DFD5;
    box-shadow: 0px 4px 16px rgba(148, 93, 63, 0.05);
    border-radius: 8px;
    width: 85%;
    height: fit-content;
    max-height: 80vh;
    overflow-y: auto;
    margin: auto;
    margin-top: 40px;
    padding: 32px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.UploadProperties::-webkit-scrollbar {
    width: 6px;
    height: 10px;
}

::-webkit-scrollbar-thumb {
    background: #D9D9D9;
    border-radius: 10px;
}

.UploadPropertiesHeading>span {
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    color: #3F3325;
}

.UploadFields {
    display: flex;
    gap: 40px;
    flex-wrap: wrap;
    justify-content: center;
    /* align-items: center; */
}

.UploadImagesGroup {
    width: 192px;
    height: 192px;
    border-radius: 8px;
    display: grid;
    /* background-color: #9A938A; */
}

.UploadImagesGroup>div {
    width: 100%;
    height: 100px;
}

.UploadImagesGroup>div>img {
    width: 100%;
    height: 100%;

}

.UploadImagesSingle {
    width: 220px;
    height: 220px;
}


.UploadMapProperties {
    width: 192px;
    height: 192px;
    border-radius: 8px;
    /* background-color: #9A938A; */
}

.DirectionDropdown>input,
.DirectionDropdown>select {
    border: 1px solid #E8DFD5;
    border-radius: 8px;
    min-width: 220px;
    height: 40px;
    font-weight: 400;
    font-size: 14px;
    padding: 0.6rem;
    background: #FFFF;
    line-height: 20px;
    cursor: pointer;
}

.DirectionDropdown>input::placeholder {
    font-weight: 400 !important;
    font-size: 14px !important;
    line-height: 20px !important;
    color: #594F42 !important;
    opacity: 0.4 !important;

}


.DirectionDropdown>select:invalid {
    font-weight: 400 !important;
    font-size: 14px !important;
    line-height: 20px !important;
    color: #594F42 !important;
    opacity: 0.6 !important;
}

.DirectionDropdown>input:focus-visible,
select:focus-visible {
    outline: none;
    border: 1px solid #9A938A;
}


.UploadLocations {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.UploadTigerLocations {
    display: flex;
    flex-direction: row;
    gap: 24px;
}

.OrText {
    text-align: center;
    font-size: 12px;
    opacity: 0.5;
}

.disabledInput {
    opacity: 0.3;
}

.DirectionDropdown {
    display: flex;
    flex-direction: column;
    position: relative;

}

.DirectionDropdown>img {
    position: absolute;
    top: 30px;
    right: 10px;
}

.DirectionDropdown>label {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #594F42;
}

.disabledValue {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #594F42;
    /* opacity: 0.4; */
    border: 2px solid;
}

.UploadParameters {
    display: flex;
    /* align-items: center; */
    gap: 10px;
    flex-wrap: wrap;
    justify-content: center;
}

.UploadTigerParameters {
    display: flex;
    flex-direction: column;
    align-items: left;
    gap: 10px;
    flex-wrap: wrap;
    justify-content: center;
}

.Cancel_button {
    background: #EDF3F2;
    border-radius: 8px;
    display: flex;
    width: 114px;
    height: 40px;
    justify-content: center;
    cursor: pointer;
    align-items: center;
    padding: 10px 16px;
}

.Cancel_button>span {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #38514C;
}

.Upload_Cancel_button {
    background: #EDF3F2;
    border-radius: 8px;
    display: flex;
    width: 184px;
    height: 40px;
    justify-content: center;
    cursor: pointer;
    align-items: center;
    padding: 10px 16px;
}

.Upload_Cancel_button>span {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #38514C;
}

.Upload_button>span {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #FFFFFF;
}

.Upload_button {
    display: flex;
    background: #E67817;
    border: 1px solid #FAE4D1;
    border-radius: 8px;
    width: 114px;
    height: 40px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding: 10px 16px;
}

.UploadPropertiesButton {
    display: flex;
    margin-top: 60px;
    gap: 10px;
    justify-content: flex-end;
}

.WeeklyButtons.UploadPropertiesButton {
    margin-top: 4vh !important;
}

.upload_disabled {
    width: 114px;
    height: 40px;
    left: 130px;
    top: 0px;
    background: #FAE4D1;
    border: 1px solid #FAE4D1;
    border-radius: 8px;
}

.UploadLoader {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 24px;
    justify-content: center;
}

.loader {
    animation: spin 2s linear infinite;
}

.DirectionDropdown>.rotate_img {
    animation: spin 2s linear infinite;
}

#warning {
    color: #D2281C;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.UploadLoaderHeading>span {
    font-weight: 700;
    font-size: 28px;
    line-height: 42px;
    text-align: center;
    color: #3F3325;

}


.ViewUploadedImages {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 24px;
    justify-content: center;
}

.Images_Uploaded {
    width: 238px;
    height: 42px;
}

.Images_Uploaded>span {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 700;
    font-size: 27px;
    line-height: 42px;
    text-align: center;
    color: #3F3325;
}

.ViewUploadedImagesGrid {
    display: grid;
    width: 192px;
    height: 192px;
}


.View_Uploaded_Images_Button {
    display: flex;
    gap: 20px;
}

.View_Uploaded_Images_Button>.Upload_Cancel_button {
    width: 184px;
    height: 40px;
    display: flex;
    background: #EDF3F2;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 16px;
    cursor: pointer;
}

.Upload_Cancel_button>span {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
}

.View_Uploaded_Images_Button>.Upload_Classify_button {
    background: #CB6913;
    border: 1px solid #CB6913;
    border-radius: 8px;
    width: 184px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 16px;
    cursor: pointer;
}

.Upload_Classify_button>span {
    color: #FFFFFF;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
}

.Upload_Area {
    background: #FFFFFF;
    box-shadow: 0px 4px 16px rgba(148, 93, 63, 0.05);
    border-radius: 8px;
    width: 90%;
    height: 80%;
    margin: auto;
    top: 10;
    margin-top: 40px;
}

.Upload_Area>.Setting_User {
    border-bottom: 1px solid rgb(232, 223, 213, .5);
}

.Upload_Area .Setting_User_Header {
    margin-bottom: 40px;
}

.grid_view_image {
    width: 192px;
    height: 92px;
    border-radius: 8px;
}

.grid_view_image1 {
    width: 92px;
    height: 92px;
    border-radius: 8px;
}

.loading-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.location_container {
    display: flex;
    flex-direction: column;
    /* position: absolute; */
    margin-top: -30px;
}

.spinner-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.spinner {
    display: inline-block;
    width: 25vh;
    height: 25vh;
    border: 1vw solid rgba(0, 0, 0, 0.2);
    border-radius: 50%;
    border-top-color: #E67817;
    animation: spin 1s infinite linear;
    margin-bottom: 2vh;
}

.spinner-container h2 {
    margin-bottom: 0.5vh;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}


.file-uploader {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
}

/* Hide default file input */
.hidden-input {
    display: none;
}

/* Custom file upload button */
.custom-button {
    display: inline-block;
    padding: 2vh 5vw;
    font-size: 16px;
    color: white;
    background-color: #E67817;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    transition: background 0.3s ease;
}

/* Hover effect */
.custom-button:hover {
    opacity: 90%;
}

.phase-four-container {
    background: #FFFFFF;
    box-shadow: 0px 20px 24px -4px rgba(148, 93, 63, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03);
    border-radius: 8px;
    width: 70%;
    height: 70vh;
    margin: auto;
    margin-left: 20%;
    margin-top: 5%;
    padding: 2vh 1vw;
    position: relative; /* Add relative positioning to allow absolute positioning of children */
  }

.phase-four-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 5vh;
}

.phase-four-header {
    font-size: 20px;
    font-weight: bold;
    color: #38514C;
    margin-bottom: 20px;
}

.message {
    font-weight: bold;
    margin: 15px 0;
}

.success {
    color: #28a745;
}

.error {
    color: #dc3545;
}

.upload-results {
    height: 40vh;
    overflow: auto;
    margin-top: 10px;
    padding: 2vh 2vw;
}

.file-status {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    gap: 1vw;
    width: 40vw;
    padding: 2vh 2vw;
    border-radius: 6px;
    margin-bottom: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.file-info {
    display: flex;
    align-items: center;
}

.file-icon {
    color: #007bff;
    font-size: 18px;
    margin-right: 8px;
}

.status-info {
    display: flex;
    align-items: center;
}

.success-icon {
    color: #28a745;
    font-size: 18px;
    margin-right: 5px;
}

.error-icon {
    color: #dc3545;
    font-size: 18px;
    margin-right: 5px;
}

.status-text {
    font-weight: bold;
}

.phase-4-back-button {
    background-color: #6c757d;
    /* Gray */
    color: white;
    font-size: 16px;
    font-weight: bold;
    padding: 10px 20px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
}

.phase-4-back-button:hover {
    background-color: #5a6268;
    /* Darker blue */
    transform: scale(1.05);
}

.tiger-card-container {
    width: 70vw;
    height: 90vh;
}


@media (min-width: 1540px) {

    /* Large screens */
    .tiger-card-container {
        width: 80vw;
        height: 87vh;
    }
}

@media (max-width: 1540px) {

    /* Laptops */
    .tiger-card-container {
        width: 70vw;
        height: 88vh;
    }
}


.upload-button {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #FF8214;
    width: 10vw;
    margin-top: 2vh;
    gap: 0.5vw;
    height: 6vh;
    color: white;
    border-radius: 0.6vw;
    font-size: 1rem;
    cursor: pointer;
    transition: transform 0.2s ease; /* Smooth transition for the hover effect */
  }
  
  .upload-button:hover {
    transform: scale(0.98);
  }
  
  /* Disabled button style */
  .upload-button.disabled {
    background-color: #ccc; /* Dimmed background */
    color: #666; /* Dimmed text */
    cursor: not-allowed; /* Change cursor to 'not-allowed' */
  }
  
  .upload-button.disabled:hover {
    transform: none; /* Disable the hover effect when button is disabled */
  }
  

.cancel-button {
    position: absolute;
    bottom: 10px;
    left: 10px; 
    display: flex;
    align-items: center;
    cursor: pointer;
    font-weight: bold;
    padding: 1vh 1vw;
  }
  
  .cancel-button span {
    font-size: 1rem;
  }

  .cancel-button:hover {
    transform: scale(0.98);
}

.bulk-upload-container{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1vh;
    margin-top: 4vh;
    width: 50vw;
}

.bulk-progress-info{
    font-weight: bold;
}

.progress-bar{
    height: 2vh;
    width: 100%;
    background: #ddd;
    border-radius: 0.5vw;
}`, "",{"version":3,"sources":["webpack://./src/CSS/Upload.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,+FAA+F;IAC/F,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;AAC3B;;AAEA;;;IAGI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;AACZ;;;AAGA;IACI,6DAA4D;IAC5D,WAAW;IACX,aAAa;IACb,kCAAkC;IAClC,4BAA4B;IAC5B,sBAAsB;IACtB,cAAc;AAClB;;;AAGA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,gDAAgD;IAChD,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;;AAEhB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;;AAGA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;;IAEI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,yBAAyB;IACzB,uBAAuB;;AAE3B;;;AAGA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;;IAEI,aAAa;IACb,yBAAyB;AAC7B;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;;AAEtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,SAAS;IACT,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,QAAQ;IACR,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IAEI,kCAAkC;AACtC;;AAEA;IAEI,kCAAkC;AACtC;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAYA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;;AAElB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,aAAa;AACjB;;;AAGA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,gDAAgD;IAChD,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;IAClB,yBAAyB;IACzB,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA,4BAA4B;AAC5B;IACI,aAAa;AACjB;;AAEA,8BAA8B;AAC9B;IACI,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gCAAgC;AACpC;;AAEA,iBAAiB;AACjB;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,+FAA+F;IAC/F,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kBAAkB,EAAE,uEAAuE;EAC7F;;AAEF;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,SAAS;IACT,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,2DAA2D;IAC3D,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;;AAGA;;IAEI,kBAAkB;IAClB;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;;IAEI,YAAY;IACZ;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,UAAU;IACV,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,eAAe;IACf,+BAA+B,EAAE,2CAA2C;EAC9E;;EAEA;IACE,sBAAsB;EACxB;;EAEA,0BAA0B;EAC1B;IACE,sBAAsB,EAAE,sBAAsB;IAC9C,WAAW,EAAE,gBAAgB;IAC7B,mBAAmB,EAAE,mCAAmC;EAC1D;;EAEA;IACE,eAAe,EAAE,qDAAqD;EACxE;;;AAGF;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,oBAAoB;AACxB","sourcesContent":[".upload {\n    background: #FFFFFF;\n    box-shadow: 0px 20px 24px -4px rgba(148, 93, 63, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03);\n    border-radius: 8px;\n    width: 70%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 70%;\n    min-height: 60vh;\n    margin: auto;\n}\n\n.upload_container {\n    padding: 5%;\n    display: flex;\n    flex-direction: column;\n    gap: 30px;\n    justify-content: center;\n}\n\n.upload_heading,\n.upload_description,\n.upload_symbol {\n    display: flex;\n    justify-content: center;\n}\n\n.upload_heading>span {\n    font-weight: 700;\n    font-size: 28px;\n    line-height: 42px;\n    color: #3F3325;\n}\n\n.upload_description>span {\n    font-weight: 400;\n    font-size: 14px;\n    color: #594F42;\n    line-height: 20px;\n}\n\n.upload_button {\n    width: 100%;\n}\n\n.upload_button>button {\n    margin: auto;\n    margin-top: 50px;\n    width: 100%;\n}\n\n.popup-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.button-container {\n    margin-top: 25px;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.drop_container {\n    height: 100%;\n    justify-content: center;\n    align-items: center;\n    display: flex;\n}\n\n.drop_container>span {\n    color: #9A938A;\n    font-weight: 700;\n    font-size: 28px;\n    line-height: 42px;\n}\n\n.upload_folder {\n    position: absolute;\n    left: 70%;\n    top: 40%;\n}\n\n\n.Upload {\n    background: url('../Assets/Images/Bg_graphic.png') no-repeat;\n    width: 100%;\n    height: 100vh;\n    background-position: center center;\n    background-attachment: fixed;\n    background-size: cover;\n    overflow: auto;\n}\n\n\n.UploadProperties {\n    background: #FFFFFF;\n    border: 1px dashed #E8DFD5;\n    box-shadow: 0px 4px 16px rgba(148, 93, 63, 0.05);\n    border-radius: 8px;\n    width: 85%;\n    height: fit-content;\n    max-height: 80vh;\n    overflow-y: auto;\n    margin: auto;\n    margin-top: 40px;\n    padding: 32px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.UploadProperties::-webkit-scrollbar {\n    width: 6px;\n    height: 10px;\n}\n\n::-webkit-scrollbar-thumb {\n    background: #D9D9D9;\n    border-radius: 10px;\n}\n\n.UploadPropertiesHeading>span {\n    font-weight: 600;\n    font-size: 24px;\n    line-height: 36px;\n    color: #3F3325;\n}\n\n.UploadFields {\n    display: flex;\n    gap: 40px;\n    flex-wrap: wrap;\n    justify-content: center;\n    /* align-items: center; */\n}\n\n.UploadImagesGroup {\n    width: 192px;\n    height: 192px;\n    border-radius: 8px;\n    display: grid;\n    /* background-color: #9A938A; */\n}\n\n.UploadImagesGroup>div {\n    width: 100%;\n    height: 100px;\n}\n\n.UploadImagesGroup>div>img {\n    width: 100%;\n    height: 100%;\n\n}\n\n.UploadImagesSingle {\n    width: 220px;\n    height: 220px;\n}\n\n\n.UploadMapProperties {\n    width: 192px;\n    height: 192px;\n    border-radius: 8px;\n    /* background-color: #9A938A; */\n}\n\n.DirectionDropdown>input,\n.DirectionDropdown>select {\n    border: 1px solid #E8DFD5;\n    border-radius: 8px;\n    min-width: 220px;\n    height: 40px;\n    font-weight: 400;\n    font-size: 14px;\n    padding: 0.6rem;\n    background: #FFFF;\n    line-height: 20px;\n    cursor: pointer;\n}\n\n.DirectionDropdown>input::placeholder {\n    font-weight: 400 !important;\n    font-size: 14px !important;\n    line-height: 20px !important;\n    color: #594F42 !important;\n    opacity: 0.4 !important;\n\n}\n\n\n.DirectionDropdown>select:invalid {\n    font-weight: 400 !important;\n    font-size: 14px !important;\n    line-height: 20px !important;\n    color: #594F42 !important;\n    opacity: 0.6 !important;\n}\n\n.DirectionDropdown>input:focus-visible,\nselect:focus-visible {\n    outline: none;\n    border: 1px solid #9A938A;\n}\n\n\n.UploadLocations {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n.UploadTigerLocations {\n    display: flex;\n    flex-direction: row;\n    gap: 24px;\n}\n\n.OrText {\n    text-align: center;\n    font-size: 12px;\n    opacity: 0.5;\n}\n\n.disabledInput {\n    opacity: 0.3;\n}\n\n.DirectionDropdown {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n\n}\n\n.DirectionDropdown>img {\n    position: absolute;\n    top: 30px;\n    right: 10px;\n}\n\n.DirectionDropdown>label {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #594F42;\n}\n\n.disabledValue {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #594F42;\n    /* opacity: 0.4; */\n    border: 2px solid;\n}\n\n.UploadParameters {\n    display: flex;\n    /* align-items: center; */\n    gap: 10px;\n    flex-wrap: wrap;\n    justify-content: center;\n}\n\n.UploadTigerParameters {\n    display: flex;\n    flex-direction: column;\n    align-items: left;\n    gap: 10px;\n    flex-wrap: wrap;\n    justify-content: center;\n}\n\n.Cancel_button {\n    background: #EDF3F2;\n    border-radius: 8px;\n    display: flex;\n    width: 114px;\n    height: 40px;\n    justify-content: center;\n    cursor: pointer;\n    align-items: center;\n    padding: 10px 16px;\n}\n\n.Cancel_button>span {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    display: flex;\n    align-items: center;\n    color: #38514C;\n}\n\n.Upload_Cancel_button {\n    background: #EDF3F2;\n    border-radius: 8px;\n    display: flex;\n    width: 184px;\n    height: 40px;\n    justify-content: center;\n    cursor: pointer;\n    align-items: center;\n    padding: 10px 16px;\n}\n\n.Upload_Cancel_button>span {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    display: flex;\n    align-items: center;\n    color: #38514C;\n}\n\n.Upload_button>span {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    display: flex;\n    align-items: center;\n    color: #FFFFFF;\n}\n\n.Upload_button {\n    display: flex;\n    background: #E67817;\n    border: 1px solid #FAE4D1;\n    border-radius: 8px;\n    width: 114px;\n    height: 40px;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    padding: 10px 16px;\n}\n\n.UploadPropertiesButton {\n    display: flex;\n    margin-top: 60px;\n    gap: 10px;\n    justify-content: flex-end;\n}\n\n.WeeklyButtons.UploadPropertiesButton {\n    margin-top: 4vh !important;\n}\n\n.upload_disabled {\n    width: 114px;\n    height: 40px;\n    left: 130px;\n    top: 0px;\n    background: #FAE4D1;\n    border: 1px solid #FAE4D1;\n    border-radius: 8px;\n}\n\n.UploadLoader {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    gap: 24px;\n    justify-content: center;\n}\n\n.loader {\n    -webkit-animation: spin 2s linear infinite;\n    animation: spin 2s linear infinite;\n}\n\n.DirectionDropdown>.rotate_img {\n    -webkit-animation: spin 2s linear infinite;\n    animation: spin 2s linear infinite;\n}\n\n#warning {\n    color: #D2281C;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 18px;\n}\n\n@-webkit-keyframes spin {\n    0% {\n        -webkit-transform: rotate(0deg);\n    }\n\n    100% {\n        -webkit-transform: rotate(360deg);\n    }\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.UploadLoaderHeading>span {\n    font-weight: 700;\n    font-size: 28px;\n    line-height: 42px;\n    text-align: center;\n    color: #3F3325;\n\n}\n\n\n.ViewUploadedImages {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    gap: 24px;\n    justify-content: center;\n}\n\n.Images_Uploaded {\n    width: 238px;\n    height: 42px;\n}\n\n.Images_Uploaded>span {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 27px;\n    line-height: 42px;\n    text-align: center;\n    color: #3F3325;\n}\n\n.ViewUploadedImagesGrid {\n    display: grid;\n    width: 192px;\n    height: 192px;\n}\n\n\n.View_Uploaded_Images_Button {\n    display: flex;\n    gap: 20px;\n}\n\n.View_Uploaded_Images_Button>.Upload_Cancel_button {\n    width: 184px;\n    height: 40px;\n    display: flex;\n    background: #EDF3F2;\n    border-radius: 8px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 10px 16px;\n    cursor: pointer;\n}\n\n.Upload_Cancel_button>span {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n}\n\n.View_Uploaded_Images_Button>.Upload_Classify_button {\n    background: #CB6913;\n    border: 1px solid #CB6913;\n    border-radius: 8px;\n    width: 184px;\n    height: 40px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 10px 16px;\n    cursor: pointer;\n}\n\n.Upload_Classify_button>span {\n    color: #FFFFFF;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n}\n\n.Upload_Area {\n    background: #FFFFFF;\n    box-shadow: 0px 4px 16px rgba(148, 93, 63, 0.05);\n    border-radius: 8px;\n    width: 90%;\n    height: 80%;\n    margin: auto;\n    top: 10;\n    margin-top: 40px;\n}\n\n.Upload_Area>.Setting_User {\n    border-bottom: 1px solid rgb(232, 223, 213, .5);\n}\n\n.Upload_Area .Setting_User_Header {\n    margin-bottom: 40px;\n}\n\n.grid_view_image {\n    width: 192px;\n    height: 92px;\n    border-radius: 8px;\n}\n\n.grid_view_image1 {\n    width: 92px;\n    height: 92px;\n    border-radius: 8px;\n}\n\n.loading-mask {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(255, 255, 255, 0.8);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999;\n}\n\n.location_container {\n    display: flex;\n    flex-direction: column;\n    /* position: absolute; */\n    margin-top: -30px;\n}\n\n.spinner-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.spinner {\n    display: inline-block;\n    width: 25vh;\n    height: 25vh;\n    border: 1vw solid rgba(0, 0, 0, 0.2);\n    border-radius: 50%;\n    border-top-color: #E67817;\n    animation: spin 1s infinite linear;\n    margin-bottom: 2vh;\n}\n\n.spinner-container h2 {\n    margin-bottom: 0.5vh;\n}\n\n@keyframes spin {\n    from {\n        transform: rotate(0deg);\n    }\n\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n\n.file-uploader {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n}\n\n/* Hide default file input */\n.hidden-input {\n    display: none;\n}\n\n/* Custom file upload button */\n.custom-button {\n    display: inline-block;\n    padding: 2vh 5vw;\n    font-size: 16px;\n    color: white;\n    background-color: #E67817;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: background 0.3s ease;\n}\n\n/* Hover effect */\n.custom-button:hover {\n    opacity: 90%;\n}\n\n.phase-four-container {\n    background: #FFFFFF;\n    box-shadow: 0px 20px 24px -4px rgba(148, 93, 63, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03);\n    border-radius: 8px;\n    width: 70%;\n    height: 70vh;\n    margin: auto;\n    margin-left: 20%;\n    margin-top: 5%;\n    padding: 2vh 1vw;\n    position: relative; /* Add relative positioning to allow absolute positioning of children */\n  }\n\n.phase-four-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 5vh;\n}\n\n.phase-four-header {\n    font-size: 20px;\n    font-weight: bold;\n    color: #38514C;\n    margin-bottom: 20px;\n}\n\n.message {\n    font-weight: bold;\n    margin: 15px 0;\n}\n\n.success {\n    color: #28a745;\n}\n\n.error {\n    color: #dc3545;\n}\n\n.upload-results {\n    height: 40vh;\n    overflow: auto;\n    margin-top: 10px;\n    padding: 2vh 2vw;\n}\n\n.file-status {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: #fff;\n    gap: 1vw;\n    width: 40vw;\n    padding: 2vh 2vw;\n    border-radius: 6px;\n    margin-bottom: 10px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.file-info {\n    display: flex;\n    align-items: center;\n}\n\n.file-icon {\n    color: #007bff;\n    font-size: 18px;\n    margin-right: 8px;\n}\n\n.status-info {\n    display: flex;\n    align-items: center;\n}\n\n.success-icon {\n    color: #28a745;\n    font-size: 18px;\n    margin-right: 5px;\n}\n\n.error-icon {\n    color: #dc3545;\n    font-size: 18px;\n    margin-right: 5px;\n}\n\n.status-text {\n    font-weight: bold;\n}\n\n.phase-4-back-button {\n    background-color: #6c757d;\n    /* Gray */\n    color: white;\n    font-size: 16px;\n    font-weight: bold;\n    padding: 10px 20px;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: background-color 0.3s ease, transform 0.2s ease;\n    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);\n}\n\n.phase-4-back-button:hover {\n    background-color: #5a6268;\n    /* Darker blue */\n    transform: scale(1.05);\n}\n\n.tiger-card-container {\n    width: 70vw;\n    height: 90vh;\n}\n\n\n@media (min-width: 1540px) {\n\n    /* Large screens */\n    .tiger-card-container {\n        width: 80vw;\n        height: 87vh;\n    }\n}\n\n@media (max-width: 1540px) {\n\n    /* Laptops */\n    .tiger-card-container {\n        width: 70vw;\n        height: 88vh;\n    }\n}\n\n\n.upload-button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #FF8214;\n    width: 10vw;\n    margin-top: 2vh;\n    gap: 0.5vw;\n    height: 6vh;\n    color: white;\n    border-radius: 0.6vw;\n    font-size: 1rem;\n    cursor: pointer;\n    transition: transform 0.2s ease; /* Smooth transition for the hover effect */\n  }\n  \n  .upload-button:hover {\n    transform: scale(0.98);\n  }\n  \n  /* Disabled button style */\n  .upload-button.disabled {\n    background-color: #ccc; /* Dimmed background */\n    color: #666; /* Dimmed text */\n    cursor: not-allowed; /* Change cursor to 'not-allowed' */\n  }\n  \n  .upload-button.disabled:hover {\n    transform: none; /* Disable the hover effect when button is disabled */\n  }\n  \n\n.cancel-button {\n    position: absolute;\n    bottom: 10px;\n    left: 10px; \n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    font-weight: bold;\n    padding: 1vh 1vw;\n  }\n  \n  .cancel-button span {\n    font-size: 1rem;\n  }\n\n  .cancel-button:hover {\n    transform: scale(0.98);\n}\n\n.bulk-upload-container{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1vh;\n    margin-top: 4vh;\n    width: 50vw;\n}\n\n.bulk-progress-info{\n    font-weight: bold;\n}\n\n.progress-bar{\n    height: 2vh;\n    width: 100%;\n    background: #ddd;\n    border-radius: 0.5vw;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
